import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';

// Actions
export const SEND_CONTACT_US_EMAIL = 'SEND_CONTACT_US_EMAIL';
export const SEND_CONTACT_US_EMAIL_SUCCESS = 'SEND_CONTACT_US_EMAIL_SUCCESS';
export const SEND_CONTACT_US_EMAIL_FAIL = 'SEND_CONTACT_US_EMAIL_FAIL';
export const SEND_SHARE_EMAIL = 'SEND_SHARE_EMAIL';
export const SEND_SHARE_EMAIL_SUCCESS = 'SEND_SHARE_EMAIL_SUCCESS';
export const SEND_SHARE_EMAIL_FAIL = 'SEND_SHARE_EMAIL_FAIL';

// Action Creators
export function sendContactUsEmail(payload) {
  return { type: SEND_CONTACT_US_EMAIL, payload };
}

export function sendContactUsEmailSuccess(payload) {
  return { type: SEND_CONTACT_US_EMAIL_SUCCESS, payload };
}

export function sendContactUsEmailFail(payload) {
  return { type: SEND_CONTACT_US_EMAIL_FAIL, payload };
}

export function sendShareEmail(payload) {
  return { type: SEND_SHARE_EMAIL, payload };
}

export function sendShareEmailSuccess(payload) {
  return { type: SEND_SHARE_EMAIL_SUCCESS, payload };
}

export function sendShareEmailFail(payload) {
  return { type: SEND_SHARE_EMAIL_FAIL, payload };
}

// Requests
export function requestSendContactUsEmail(payload) {
  return callApi('email_sender/contact_us/', 'POST', payload);
}

export function requestSendShareEmail(payload) {
  return callApi('email_sender/send_emails/invitation/', 'POST', payload);
}

function* sendContactUsEmailSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestSendContactUsEmail, values);
    yield put(sendContactUsEmailSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Thanks for your email, we will process it as soon as we can',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(sendContactUsEmailFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* sendShareEmailSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestSendShareEmail, values);
    yield put(sendShareEmailSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Emails were successfully send',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(sendShareEmailFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* emailsSaga() {
  yield takeEvery(SEND_CONTACT_US_EMAIL, sendContactUsEmailSaga);
  yield takeEvery(SEND_SHARE_EMAIL, sendShareEmailSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/emails.js